'use client'

import { useLocale } from 'next-intl'

import Loader from '@/shared/ui/Loader'

import { useNewsHeroFeatured } from '../../hooks/useNewsHeroFeatured'
import S from './NewsHeroFeatured.module.scss'
import NewsHeroMainCard from './NewsHeroMainCard'
import NewsHeroSideArticle from './NewsHeroSideArticle'

const NewsHeroFeatured = () => {
  const locale = useLocale()
  const { items, isLoading } = useNewsHeroFeatured()
  const [mainNews, ...sideNews] = items

  if (isLoading) {
    return (
      <div className={S.root}>
        <div className={S.loader}>
          <Loader variant="inline" />
        </div>
      </div>
    )
  }

  if (!mainNews) {
    return null
  }

  return (
    <div className={S.root}>
      <div className={S.container}>
        <NewsHeroMainCard news={mainNews} locale={locale} />
        {sideNews.length > 0 && (
          <div className={S.sideColumn}>
            {sideNews.slice(0, 3).map(news => (
              <NewsHeroSideArticle key={news.id} news={news} locale={locale} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default NewsHeroFeatured
